module.exports = __webpack_public_path__ + "img/Settings.8ff53e8e.jpg";